import React from "react";

import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import { useDispatch } from "react-redux";

function TrashAll() {
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch({ type: "EMPTY_CART" });
  };
  return (
    <Tooltip title="Empty cart">
      <IconButton aria-label="delete" size="small" onClick={handleClick}>
        <DeleteIcon fontSize="inherit" />
      </IconButton>
    </Tooltip>
  );
}

export default TrashAll;
